import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { RetrieveFilesResult } from "../types/RetrieveFilesResult";

export const useRetrieveUnsignedCOC = (
	retailOrderID: number,
	onSuccess: (result: RetrieveFilesResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/retrieve-unsigned-coc",
				{
					retailOrderID: retailOrderID
				}) as RetrieveFilesResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError(result.errorMessage!);
		},
		onError: async (error) => {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
